const project = {
  slug: "talent-pool-automation-system",
  title: "Talent Pool Automation System (ATS-Style)",
  oneLiner: "Gmail ingest, resume parsing, Drive upload, AI CV analysis, and candidate DB updates.",
  role: ["Automation Engineer", "AI Workflow Designer"],
  category: "AI/ML",
  clientOrOrg: "Automation Engineering (n8n + OpenAI Workflows)",
  timeframe: { start: "2025-02", status: "Shipped" },
  domain: ["Automation", "TalentOps", "AI"],
  tech: ["n8n", "OpenAI", "Google Drive", "PDF parsing", "Gmail"],
  links: {},
  impact: [
    "Automated talent pipeline from inbox to Drive to AI screening with database sync.",
    "Cut manual resume triage by auto-extracting and summarizing candidates."
  ],
  responsibilities: [
    "Built Gmail triggers for resume intake",
    "Implemented PDF conversion + parsing and Drive uploads",
    "Designed AI analysis for CV insights",
    "Updated candidate database automatically"
  ],
  features: [
    "Gmail → resume extraction",
    "PDF conversion and parsing",
    "Drive upload & cataloging",
    "AI CV analysis and tagging",
    "Candidate DB updates"
  ],
  architecture: [
    "n8n flows for ingest + storage",
    "OpenAI for CV analysis",
    "Drive + DB connectors for persistence"
  ],
  seo: {
    title: "Talent Pool Automation System - n8n + OpenAI",
    description: "ATS-style automation that ingests resumes from Gmail, parses PDFs, runs AI analysis, and updates the candidate DB."
  },
  cover: "/assets/talent-pool/talent-pool-featured.png"
};

export default project;
